import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter, forwardRef } from '@angular/core';
import { 
    IonIcon
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import moment from 'moment';

import { MarvDateToStringPipe } from '@marv/pipes';
import { MarvMessageComponent, MarvTagComponent } from '@marv/components';
import { MarvDateService } from '@marv/services';
import { MissionItem, PlanningItem, PlanningItemComponent } from '@app/components';
import { MissionTypeService } from '@app/services';

class DayOperation {
    id: number;
    name: string;
    typeOfMission: string;
    source: string;
    nbMissions: number;
}

class Day {
    day: Date;
    planningItems: Array<PlanningItem>;
    operations: Array<DayOperation>;
    today?: boolean;
    isOpened: boolean;
}

class Week {
    numWeek: number;
    startDate: Date;
    endDate: Date;    
    todayWeek?: boolean;
    days: Array<Day>;
    isOpened: boolean;
}

@Component({
    selector: 'app-planning-month',
    templateUrl: './month.component.html',
    styleUrls: ['./month.component.scss'],
    imports: [
        IonIcon, TranslatePipe, 
        forwardRef(() => MarvMessageComponent), forwardRef(() => MarvDateToStringPipe), forwardRef(() => MarvTagComponent), forwardRef(() => PlanningItemComponent)
    ]
})
export class PlanningMonthComponent  implements OnInit {

    @Input({alias : 'missions', required : true}) missionsItems: Array<MissionItem> = [];
    @Input({alias : 'startDate', required : true}) startDate: Date;
    @Input({alias : 'endDate', required : true}) endDate: Date;
    @Input({alias : 'weekDays', required : false}) weekDays: Array<number>|undefined;
    @Output() onSelectMission = new EventEmitter<MissionItem>();

    isFetching: boolean = false; 
    weeks: Array<Week> = [];

    constructor(
        public missionTypeService: MissionTypeService
    ) { }

    ngOnInit() {}

    ngOnChanges(changes: SimpleChanges) {
        if(changes['missionsItems']){
            this.displayPlanning();
        }
    }
    
    displayPlanning(){
        this.isFetching = true;
        this.weeks = [];
        let weeks: Array<Week> = [];
        
        let cpt = 1;
        let now = new Date();
        let week = moment(this.startDate);
        let endDate = moment(this.endDate);
        while (week <= endDate && cpt <= 6){        
            
            let days: Array<Day> = [];
            let start = MarvDateService.GetFirstDayOfWeek(week.toDate());
            let end = MarvDateService.GetLastDayOfWeek(week.toDate());
            let weeksMissions: Array<MissionItem> = this.missionsItems.filter(m => {
                let mDay = MarvDateService.ToDate(m.day)
                return (mDay && start <= mDay && mDay <= end);
            });
            
            let cpt2=0;
            let dayWeek = moment(start);
            while (dayWeek <= moment(end) && cpt2 <= 8){    
             
                if(!this.weekDays || this.weekDays.indexOf(parseInt(dayWeek.format('E'))) !== -1){                
             
                    let dayOperations: Array<DayOperation> = [];
                    let daysMissions = weeksMissions.filter(m => {
                        let mDay = MarvDateService.ToDate(m.day)
                        return moment(mDay).format('YYYY-MM-DD') === dayWeek.format('YYYY-MM-DD');
                    });

                    for(let dm of daysMissions){ 
                        let existOp = dayOperations.find(dop => dop.id === dm.operation.id && dm.operation.source === dop.source);
                        if(existOp){
                            existOp.nbMissions++;
                        }
                        else{
                            dayOperations.push({
                                id: dm.operation.id,
                                name: dm.operation.name,
                                typeOfMission: dm.operation.typeOfMission,
                                source: dm.operation.source,
                                nbMissions: 1
                            });
                        }                        
                    }
                    
                    days.push({
                        day: dayWeek.toDate(),
                        planningItems: this.fromMissionsItems(daysMissions),
                        operations: dayOperations,
                        today: (moment(now).format('YYYY-MM-DD') === dayWeek.format('YYYY-MM-DD')),
                        isOpened: false
                    });
                }
                
                dayWeek = dayWeek.add(1, 'day');
                cpt2++;
            }
            
            weeks.push({
                numWeek: parseInt(week.format('W')),
                startDate: start,
                endDate: end,
                days: days,
                todayWeek: (start <= now && now <= end),
                isOpened: false
            });
            week = week.add(1, 'week');
            cpt++;                        
        }
         
        this.weeks = weeks;
        this.isFetching = false;;
    }
    
    fromMissionsItems(missions: Array<MissionItem>): Array<PlanningItem> {
        let planningItems: Array<PlanningItem> = [];
        for(let m of missions){
            planningItems.push(PlanningItem.FromMissionItem(m, 'month'));
        }
        return planningItems;
    }
    
    selectPlanningItem(planningItem: PlanningItem){
        let missionItem = this.missionsItems.find(m => m.activityId === planningItem.activityId && m.source == planningItem.source);
        if(missionItem){
            this.onSelectMission.emit(missionItem);
        }
    }
    
    toggleWeek(week: Week){
        week.isOpened = !week.isOpened;
        for(let d of week.days){
            d.isOpened = week.isOpened;
        }
    }
    
    toggleDay(weekDay: Day){
        weekDay.isOpened = !weekDay.isOpened;
    }
    
}
